import { useCopilot } from '../../api/copilot';

/**
 * The design's `.eq` bars, shown while the agent's voice is playing.
 *
 * Driven by the provider's `speaking`, which is measured state — the agent's
 * own `lk.agent.state` or its active-speaker flag — never a timer, so the bars
 * move only when there is sound to go with them. Renders nothing otherwise,
 * so it can sit in a header permanently without holding space.
 */
export default function SpeakingIndicator({ className = '' }) {
  const { speaking = false } = useCopilot();
  if (!speaking) return null;
  return (
    <span
      className={`eq cp-eq ${className}`.trim()}
      role="img"
      aria-label="The assistant is speaking"
      title="Speaking"
    >
      <i /><i /><i /><i />
    </span>
  );
}
